import React, { useState, useEffect, useRef } from "react";
import Scrollspy from "react-scrollspy";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import WidgetContainer from "../../../components/WidgetContainer/WidgetContainer";
import LanguageSwitcher from "../../../components/LanguageSwitcher/LanguageSwitcher";
import ExternalLink from "../../../components/ExternalLink/ExternalLink";
import { setCallback } from "../../../helpers/i18next";

import loaderImage from "../../../images/privacy/pageloader.gif";
import "./PrivacyMainContentWidget.css";

const PrivacyMainContentWidget = () => {
    const privacyScrollToEl = useRef(null);
    const grievanceScrollToEl = useRef(null);
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation("PrivacyMainContentWidget");

    const handleVisibility = e => {
        if (e.target.nextSibling && e.target.childNodes[1]) {
            e.target.nextSibling.classList.toggle("visible");
            e.target.childNodes[1].classList.toggle("rotate");
        }
    };

    useEffect(() => {
        if (window && window.MutationObserver) {
            let observer = new MutationObserver(mutations => {
                if (document.contains(privacyScrollToEl.current)) {
                    if (window.location.hash === "#grievances")
                        grievanceScrollToEl.current.scrollIntoView({
                            behavior: "auto",
                        });

                    observer.disconnect();
                }
            });

            observer.observe(document, {
                attributes: false,
                childList: true,
                characterData: false,
                subtree: true,
            });
        }
    });

    if (loading) {
        setCallback(() => setLoading(false));
        return (
            <WidgetContainer>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        height: "100%",
                    }}
                >
                    <img
                        src={loaderImage}
                        style={{
                            display: "block",
                            width: "110px",
                            height: "110px",
                        }}
                    />
                    <span
                        style={{
                            marginTop: "12px",
                            fontWeight: "normal",
                            fontSize: "18px",
                            lineHeight: "130%",
                            color: "#361968",
                        }}
                    >
                        Loading...
                    </span>
                </div>
            </WidgetContainer>
        );
    } else {
        return (
            <>
                <div className="pv-invisible"></div>
                <LanguageSwitcher />
                <WidgetContainer>
                    <div className="privacy">
                        <div className="privacy__main-content-container">
                            <div className="privacy__main-content-container__sidenavbar">
                                <div className="privacy__main-content-container__sidenavbar__sticky">
                                    {
                                        <Scrollspy
                                            items={["privacy", "grievances"]}
                                            currentClassName="is-current"
                                            offset={-75}
                                        >
                                            <li>
                                                <a href="#privacy" id="pp">
                                                    {t("NAVLINKS.LI1")}
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#grievances" id="gri">
                                                    {t("NAVLINKS.LI2")}
                                                </a>
                                            </li>
                                        </Scrollspy>
                                    }
                                </div>
                            </div>

                            <div className="privacy__main-content-container__main-content">
                                <div id="privacy">
                                    <div
                                        className="privacy__main-content-container__main-content__text"
                                        ref={privacyScrollToEl}
                                    >
                                        <div
                                            className="privacy__main-content-container__main-content__text__heading"
                                            onClick={handleVisibility}
                                            id="privacy-fblock"
                                        ></div>
                                        <div>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.TOP_CONTENT.P1"
                                                )}
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.TOP_CONTENT.P2"
                                                )}
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.TOP_CONTENT.P3"
                                                )}
                                            </p>

                                            <p>
                                                <strong>
                                                    {t(
                                                        "PRIVACY_POLICY.TOP_CONTENT.P4.TITLE"
                                                    )}
                                                </strong>
                                            </p>

                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.TOP_CONTENT.P4.CONTENT.P1"
                                                )}
                                            </p>

                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.TOP_CONTENT.P4.CONTENT.P2"
                                                )}
                                            </p>
                                            <p>
                                                <strong>
                                                    {t(
                                                        "PRIVACY_POLICY.TOP_CONTENT.P5.TITLE"
                                                    )}
                                                </strong>
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.TOP_CONTENT.P5.CONTENT.P1"
                                                )}
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.TOP_CONTENT.P5.CONTENT.P2"
                                                )}
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.TOP_CONTENT.P5.CONTENT.P3"
                                                )}
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.TOP_CONTENT.P5.CONTENT.P4"
                                                )}
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.TOP_CONTENT.P5.CONTENT.P5"
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                    <h2> {t("PRIVACY_POLICY.TITLE")}</h2>

                                    <div className="privacy__main-content-container__main-content__text">
                                        <div
                                            className="privacy__main-content-container__main-content__text__heading"
                                            onClick={handleVisibility}
                                        >
                                            <h3>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_AOPP.TITLE"
                                                )}
                                            </h3>
                                            <span className="privacy__main-content-container__main-content__text__heading__icon">
                                                &#8964;
                                            </span>
                                        </div>
                                        <div className="privacy__main-content-container__main-content__text__wrapper">
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_AOPP.CONTENT.P1.PT1"
                                                )}
                                                <a href="https://www.phonepe.com/">
                                                    www.phonepe.com
                                                </a>{" "}
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_AOPP.CONTENT.P1.PT2"
                                                )}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="privacy__main-content-container__main-content__text">
                                        <div
                                            className="privacy__main-content-container__main-content__text__heading"
                                            onClick={handleVisibility}
                                        >
                                            <h3>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_SA.TITLE"
                                                )}
                                            </h3>
                                            <span className="privacy__main-content-container__main-content__text__heading__icon">
                                                &#8964;
                                            </span>
                                        </div>
                                        <div className="privacy__main-content-container__main-content__text__wrapper">
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_SA.CONTENT.P1"
                                                )}
                                            </p>

                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_SA.CONTENT.P2"
                                                )}
                                            </p>
                                        </div>
                                    </div>

                                    <div
                                        className="privacy__main-content-container__main-content__text"
                                        id="text-wrapper"
                                    >
                                        <div
                                            className="privacy__main-content-container__main-content__text__heading"
                                            onClick={handleVisibility}
                                        >
                                            <h3>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PU.TITLE"
                                                )}
                                            </h3>
                                            <span className="privacy__main-content-container__main-content__text__heading__icon">
                                                &#8964;
                                            </span>
                                        </div>
                                        <div className="privacy__main-content-container__main-content__text__wrapper">
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PU.CONTENT.P1"
                                                )}
                                            </p>

                                            <p>
                                                <ul className="lower-roman-list">
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PU.CONTENT.LIST.LIST1.L1"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {" "}
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PU.CONTENT.LIST.LIST1.L2"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PU.CONTENT.LIST.LIST1.L3"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PU.CONTENT.LIST.LIST1.L4"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PU.CONTENT.LIST.LIST1.L5"
                                                        )}
                                                    </li>
                                                </ul>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="privacy__main-content-container__main-content__text">
                                        <div
                                            className="privacy__main-content-container__main-content__text__heading"
                                            onClick={handleVisibility}
                                        >
                                            <h3>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.TITLE"
                                                )}
                                            </h3>
                                            <span className="privacy__main-content-container__main-content__text__heading__icon">
                                                &#8964;
                                            </span>
                                        </div>
                                        <div className="privacy__main-content-container__main-content__text__wrapper">
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.P1"
                                                )}
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.P2"
                                                )}
                                            </p>
                                            <p>
                                                <ul className="lower-roman-list">
                                                    <li>
                                                        {" "}
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST1.LHP"
                                                        )}
                                                        <ul className="lower-alpha-list">
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST1.L1"
                                                                )}
                                                            </li>
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST1.L2"
                                                                )}
                                                            </li>
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST1.L3"
                                                                )}
                                                            </li>
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST1.L4"
                                                                )}
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST2.LHP"
                                                        )}
                                                        <ul className="lower-alpha-list">
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST2.L1"
                                                                )}
                                                            </li>
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST2.L2"
                                                                )}
                                                            </li>
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST2.L3"
                                                                )}
                                                            </li>
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST2.L4"
                                                                )}
                                                            </li>
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST2.L5"
                                                                )}
                                                            </li>
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST2.L6"
                                                                )}
                                                            </li>
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST2.L7"
                                                                )}
                                                            </li>
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST2.L8"
                                                                )}
                                                            </li>
                                                        </ul>
                                                        <p>
                                                            {t(
                                                                "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST2.LFP"
                                                            )}
                                                        </p>
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST3.LHP"
                                                        )}
                                                        <ul className="lower-alpha-list">
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST3.L1"
                                                                )}
                                                            </li>
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST3.L2"
                                                                )}
                                                            </li>
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST3.L3"
                                                                )}
                                                            </li>
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST3.L4"
                                                                )}
                                                            </li>
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST3.L5"
                                                                )}
                                                            </li>
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST3.L6"
                                                                )}
                                                            </li>
                                                        </ul>
                                                        <p>
                                                            {t(
                                                                "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST4.LHP"
                                                            )}
                                                        </p>
                                                        <ul className="lower-alpha-list">
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST4.L1"
                                                                )}
                                                            </li>
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST4.L2"
                                                                )}
                                                            </li>
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST4.L3"
                                                                )}
                                                            </li>
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST4.L4"
                                                                )}
                                                            </li>
                                                            <li>
                                                                {t(
                                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.LIST.LIST4.L5"
                                                                )}
                                                            </li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.P3"
                                                )}
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.P4"
                                                )}
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.P5"
                                                )}
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_IC.CONTENT.P6"
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="privacy__main-content-container__main-content__text">
                                        <div
                                            className="privacy__main-content-container__main-content__text__heading"
                                            onClick={handleVisibility}
                                        >
                                            <h3>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PAUOI.TITLE"
                                                )}
                                            </h3>
                                            <span className="privacy__main-content-container__main-content__text__heading__icon">
                                                &#8964;
                                            </span>
                                        </div>
                                        <div className="privacy__main-content-container__main-content__text__wrapper">
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PAUOI.CONTENT.P1"
                                                )}
                                            </p>
                                            <p>
                                                <ul className="lower-alpha-list">
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PAUOI.CONTENT.LIST.LIST1.L1"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PAUOI.CONTENT.LIST.LIST1.L2"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PAUOI.CONTENT.LIST.LIST1.L3"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PAUOI.CONTENT.LIST.LIST1.L4"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PAUOI.CONTENT.LIST.LIST1.L5"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PAUOI.CONTENT.LIST.LIST1.L6"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PAUOI.CONTENT.LIST.LIST1.L7"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PAUOI.CONTENT.LIST.LIST1.L8"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PAUOI.CONTENT.LIST.LIST1.L9"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PAUOI.CONTENT.LIST.LIST1.L10"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PAUOI.CONTENT.LIST.LIST1.L11"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PAUOI.CONTENT.LIST.LIST1.L12"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PAUOI.CONTENT.LIST.LIST1.L13"
                                                        )}
                                                    </li>
                                                </ul>
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PAUOI.CONTENT.P2"
                                                )}
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PAUOI.CONTENT.P3"
                                                )}
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_PAUOI.CONTENT.P4"
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="privacy__main-content-container__main-content__text">
                                        <div
                                            className="privacy__main-content-container__main-content__text__heading"
                                            onClick={handleVisibility}
                                        >
                                            <h3>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ISAS.TITLE"
                                                )}
                                            </h3>
                                            <span className="privacy__main-content-container__main-content__text__heading__icon">
                                                &#8964;
                                            </span>
                                        </div>
                                        <div className="privacy__main-content-container__main-content__text__wrapper">
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ISAS.CONTENT.P1"
                                                )}
                                            </p>

                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ISAS.CONTENT.P2"
                                                )}
                                            </p>
                                            <p>
                                                <ul className="lower-alpha-list">
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ISAS.CONTENT.LIST.LIST1.L1"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ISAS.CONTENT.LIST.LIST1.L2"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ISAS.CONTENT.LIST.LIST1.L3"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ISAS.CONTENT.LIST.LIST1.L4"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ISAS.CONTENT.LIST.LIST1.L5"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ISAS.CONTENT.LIST.LIST1.L6"
                                                        )}
                                                    </li>
                                                    <li>
                                                        {t(
                                                            "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ISAS.CONTENT.LIST.LIST1.L7"
                                                        )}
                                                    </li>
                                                </ul>
                                            </p>
                                            <p>
                                                <strong>
                                                    {t(
                                                        "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ISAS.CONTENT.P3.TITLE"
                                                    )}
                                                </strong>{" "}
                                                -{" "}
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ISAS.CONTENT.P3.CONTENT.P1"
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="privacy__main-content-container__main-content__text">
                                        <div
                                            className="privacy__main-content-container__main-content__text__heading"
                                            onClick={handleVisibility}
                                        >
                                            <h3>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_SYI.TITLE"
                                                )}
                                            </h3>
                                            <span className="privacy__main-content-container__main-content__text__heading__icon">
                                                &#8964;
                                            </span>
                                        </div>
                                        <div className="privacy__main-content-container__main-content__text__wrapper">
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_SYI.CONTENT.P1"
                                                )}
                                            </p>

                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_SYI.CONTENT.P2"
                                                )}
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_SYI.CONTENT.P3"
                                                )}
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_SYI.CONTENT.P4"
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="privacy__main-content-container__main-content__text">
                                        <div
                                            className="privacy__main-content-container__main-content__text__heading"
                                            onClick={handleVisibility}
                                        >
                                            <h3>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ID.TITLE"
                                                )}
                                            </h3>
                                            <span className="privacy__main-content-container__main-content__text__heading__icon">
                                                &#8964;
                                            </span>
                                        </div>
                                        <div className="privacy__main-content-container__main-content__text__wrapper">
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ID.CONTENT.P1"
                                                )}
                                            </p>

                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ID.CONTENT.P2"
                                                )}
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ID.CONTENT.P3"
                                                )}
                                            </p>
                                            <p>
                                                <strong>
                                                    {t(
                                                        "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ID.CONTENT.P4.TITLE"
                                                    )}
                                                </strong>{" "}
                                                -{" "}
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ID.CONTENT.P4.CONTENT.P1"
                                                )}
                                            </p>
                                            <p>
                                                <strong>
                                                    {t(
                                                        "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ID.CONTENT.P5.TITLE"
                                                    )}
                                                </strong>{" "}
                                                -{" "}
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ID.CONTENT.P5.CONTENT.P1"
                                                )}
                                            </p>

                                            <p>
                                                <strong>
                                                    {t(
                                                        "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ID.CONTENT.P6.TITLE"
                                                    )}
                                                </strong>{" "}
                                                -{" "}
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ID.CONTENT.P6.CONTENT.P1"
                                                )}
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ID.CONTENT.P7"
                                                )}
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_ID.CONTENT.P8"
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="privacy__main-content-container__main-content__text">
                                        <div
                                            className="privacy__main-content-container__main-content__text__heading"
                                            onClick={handleVisibility}
                                        >
                                            <h3>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_UDACO.TITLE"
                                                )}
                                            </h3>
                                            <span className="privacy__main-content-container__main-content__text__heading__icon">
                                                &#8964;
                                            </span>
                                        </div>
                                        <div className="privacy__main-content-container__main-content__text__wrapper">
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_UDACO.CONTENT.P1"
                                                )}
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_UDACO.CONTENT.P2"
                                                )}
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_UDACO.CONTENT.P3"
                                                )}
                                            </p>
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_UDACO.CONTENT.P4"
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                    <div
                                        className="privacy__main-content-container__main-content__text"
                                        id="text-wrapper"
                                    >
                                        <div
                                            className="privacy__main-content-container__main-content__text__heading"
                                            onClick={handleVisibility}
                                        >
                                            <h3>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_FQ.TITLE"
                                                )}
                                            </h3>
                                            <span className="privacy__main-content-container__main-content__text__heading__icon">
                                                &#8964;
                                            </span>
                                        </div>
                                        <div
                                            className="privacy__main-content-container__main-content__text__wrapper"
                                            id="last"
                                        >
                                            <p>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_FQ.CONTENT.P1.P1T1"
                                                )}{" "}
                                                <a
                                                    href="https://support.phonepe.com"
                                                    target="_blank"
                                                >
                                                    {" "}
                                                    https://support.phonepe.com
                                                </a>
                                                {t(
                                                    "PRIVACY_POLICY.MAIN_CONTENT_SECTION.MCS_FQ.CONTENT.P1.P1T2"
                                                )}{" "}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                {/* <span ></span> */}
                                <div id="grievances">
                                    <h2>
                                        {t(
                                            "GRIEVANCE_POLICY.TOP_CONTENT.TITLE"
                                        )}
                                    </h2>

                                    <div
                                        className="privacy__main-content-container__main-content__text"
                                        ref={grievanceScrollToEl}
                                        id="grievances-fblock"
                                    >
                                        <div
                                            className="privacy__main-content-container__main-content__text__heading"
                                            onClick={handleVisibility}
                                        >
                                            <h3>
                                                {t(
                                                    "GRIEVANCE_POLICY.TOP_CONTENT.TITLE"
                                                )}
                                            </h3>
                                            <span className="privacy__main-content-container__main-content__text__heading__icon">
                                                &#8964;
                                            </span>
                                        </div>
                                        <div className="privacy__main-content-container__main-content__text__wrapper visible">
                                            <p>
                                                {t(
                                                    "GRIEVANCE_POLICY.TOP_CONTENT.CONTENT.P1"
                                                )}
                                            </p>

                                            <p>
                                                {t(
                                                    "GRIEVANCE_POLICY.TOP_CONTENT.CONTENT.P2"
                                                )}
                                            </p>

                                            <p>
                                                {t(
                                                    "GRIEVANCE_POLICY.TOP_CONTENT.CONTENT.P3"
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="privacy__main-content-container__main-content__text">
                                        <div
                                            className="privacy__main-content-container__main-content__text__heading"
                                            onClick={handleVisibility}
                                        >
                                            <h3>
                                                {t(
                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.TITLE"
                                                )}
                                            </h3>
                                            <span className="privacy__main-content-container__main-content__text__heading__icon">
                                                &#8964;
                                            </span>
                                        </div>
                                        <div
                                            className="privacy__main-content-container__main-content__text__wrapper"
                                            id="last"
                                        >
                                            <p>
                                                {t(
                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.P1"
                                                )}
                                            </p>

                                            <p>
                                                {t(
                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.P2"
                                                )}
                                            </p>

                                            <p>
                                                {t(
                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.P3"
                                                )}
                                            </p>

                                            <h3 className="privacy__main-content-container__main-content__text__sub-heading">
                                                {t(
                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST1.TITLE"
                                                )}
                                            </h3>
                                            <ol>
                                                <li>
                                                    {" "}
                                                    {t(
                                                        "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST1.CONTENT.NLIST1.LHP"
                                                    )}
                                                    <ul>
                                                        <li>
                                                            <span>
                                                                {t(
                                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST1.CONTENT.NLIST1.L1"
                                                                )}
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span>
                                                                {t(
                                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST1.CONTENT.NLIST1.L2"
                                                                )}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    {t(
                                                        "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST1.CONTENT.NLIST2.LHP"
                                                    )}
                                                    <ul>
                                                        <li>
                                                            <span>
                                                                {t(
                                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST1.CONTENT.NLIST2.L1"
                                                                )}
                                                            </span>
                                                        </li>

                                                        <li>
                                                            <span>
                                                                {t(
                                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST1.CONTENT.NLIST2.L2"
                                                                )}
                                                            </span>
                                                        </li>

                                                        <li>
                                                            <span>
                                                                {t(
                                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST1.CONTENT.NLIST2.L3"
                                                                )}
                                                            </span>
                                                        </li>

                                                        <li>
                                                            <span>
                                                                {t(
                                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST1.CONTENT.NLIST2.L4"
                                                                )}
                                                            </span>
                                                        </li>

                                                        <li>
                                                            <span>
                                                                {t(
                                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST1.CONTENT.NLIST2.L5"
                                                                )}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ol>
                                            <h3 className="privacy__main-content-container__main-content__text__sub-heading">
                                                {t(
                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST2.TITLE"
                                                )}
                                            </h3>
                                            <ol>
                                                <li>
                                                    {t(
                                                        "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST2.CONTENT.NLIST1.LHP"
                                                    )}
                                                    <ul>
                                                        <li>
                                                            <span>
                                                                {t(
                                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST2.CONTENT.NLIST1.L1.L1T1"
                                                                )}
                                                                &nbsp;
                                                                <a
                                                                    href="https://support.phonepe.com"
                                                                    target="_blank"
                                                                >
                                                                    https://support.phonepe.com
                                                                </a>
                                                                &nbsp;{" "}
                                                                {t(
                                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST2.CONTENT.NLIST1.L1.L1T2"
                                                                )}
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span>
                                                                {t(
                                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST2.CONTENT.NLIST1.L2"
                                                                )}
                                                                <br />
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    {t(
                                                        "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST2.CONTENT.NLIST2.LHP"
                                                    )}
                                                    <ul>
                                                        <li>
                                                            <span>
                                                                {t(
                                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST2.CONTENT.NLIST2.L1"
                                                                )}
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span>
                                                                {t(
                                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST2.CONTENT.NLIST2.L2"
                                                                )}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ol>
                                            <h3 className="privacy__main-content-container__main-content__text__sub-heading">
                                                {t(
                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST3.TITLE"
                                                )}
                                            </h3>
                                            <p>
                                                {t(
                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST3.CONTENT.P1"
                                                )}
                                            </p>
                                            <h4>
                                                {t(
                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST3.CONTENT.NLIST1.LHP"
                                                )}
                                            </h4>
                                            <ul>
                                                <li className="rm_bullet">
                                                    {t(
                                                        "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST3.CONTENT.NLIST1.L1"
                                                    )}
                                                </li>
                                                <li className="rm_bullet">
                                                    {t(
                                                        "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST3.CONTENT.NLIST1.L2"
                                                    )}{" "}
                                                    <a
                                                        href="https://grievance.phonepe.com/"
                                                        target="_blank"
                                                    >
                                                        grievance.phonepe.com
                                                    </a>
                                                </li>
                                                <li className="rm_bullet">
                                                    {t(
                                                        "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST3.CONTENT.NLIST1.L3"
                                                    )}
                                                </li>
                                                <li className="rm_bullet">
                                                    {t(
                                                        "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST3.CONTENT.NLIST1.L4"
                                                    )}
                                                </li>
                                                <li className="rm_bullet">
                                                    {t(
                                                        "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST3.CONTENT.NLIST1.L5"
                                                    )}
                                                </li>
                                                <li className="rm_bullet">
                                                    {t(
                                                        "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST3.CONTENT.NLIST1.L6"
                                                    )}
                                                </li>
                                            </ul>
                                            <br />
                                            <br />
                                            <ol>
                                                <li>
                                                    {t(
                                                        "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST3.CONTENT.NLIST2.LHP"
                                                    )}{" "}
                                                    –
                                                    <ul>
                                                        <li>
                                                            <span>
                                                                {t(
                                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST3.CONTENT.NLIST2.L1"
                                                                )}
                                                            </span>
                                                        </li>

                                                        <li>
                                                            <span>
                                                                {t(
                                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST3.CONTENT.NLIST2.L2"
                                                                )}
                                                            </span>
                                                        </li>

                                                        <li>
                                                            <span>
                                                                {t(
                                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST3.CONTENT.NLIST2.L3"
                                                                )}
                                                            </span>
                                                        </li>

                                                        <li>
                                                            <span>
                                                                {t(
                                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST3.CONTENT.NLIST2.L4"
                                                                )}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </li>

                                                <li>
                                                    {t(
                                                        "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST3.CONTENT.NLIST3.LHP"
                                                    )}
                                                    <ul>
                                                        <li>
                                                            <span>
                                                                {t(
                                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST3.CONTENT.NLIST3.L1"
                                                                )}
                                                            </span>
                                                        </li>

                                                        <li>
                                                            <span>
                                                                {t(
                                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST3.CONTENT.NLIST3.L2"
                                                                )}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ol>
                                            <h3 className="privacy__main-content-container__main-content__text__sub-heading">
                                                {t(
                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST4.TITLE"
                                                )}
                                            </h3>
                                            <p>
                                                {t(
                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST4.CONTENT.P1.P1T1"
                                                )}
                                                -{" "}
                                                {
                                                    <ExternalLink
                                                        extURL="https://rbidocs.rbi.org.in/rdocs/Content/PDFs/OSDT31012019.pdf"
                                                        extURLText="RBI Ombudsman"
                                                        extStyleClass="deep-purple-text"
                                                    />
                                                }
                                                {t(
                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST4.CONTENT.P1.P1T2"
                                                )}
                                            </p>
                                            <h3 className="privacy__main-content-container__main-content__text__sub-heading">
                                                {t(
                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST5.TITLE"
                                                )}
                                            </h3>
                                            <p>
                                                {t(
                                                    "GRIEVANCE_POLICY.MAIN_CONTENT.MC_GR.CONTENT.LIST.LIST5.CONTENT.P1.P1T1"
                                                )}
                                                -{" "}
                                                {
                                                    <ExternalLink
                                                        extURL="https://www.rbi.org.in/Scripts/NotificationUser.aspx?Id=11446&Mode=0"
                                                        extURLText="here"
                                                        extStyleClass="deep-purple-text"
                                                    />
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </WidgetContainer>
            </>
        );
    }
};

export default PrivacyMainContentWidget;
